import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom'
import styled from 'styled-components'
import Footer from './components/Footer'
import { GlobalStyles } from './components/GlobalStyles'
import Nav from './components/Nav'
import ProtectedRoute from './components/ProtectedRoute'
import ProtectedRouteWeak from './components/ProtectedRouteWeak'
import Auth from './contexts/Auth'
import AccountSetup from './pages/AccountSetup'
import AdminReleases from './pages/AdminReleases'
import CookiePolicy from './pages/CookiePolicy'
import Landing from './pages/Landing'
import PrivacyPolicy from './pages/PrivacyPolicy'
import ReferralLink from './pages/ReferralLink'
import Release from './pages/Release'
import SettingsPage from './pages/SettingsPage'
import Setup from './pages/Setup'
import StaffAlertsPage from './pages/StaffAlertsPage'
import StaffReleasesPage from './pages/StaffReleasesPage'
import Subscriptions from './pages/Subscriptions'
import Success from './pages/Success'
import ToS from './pages/ToS'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import StaffStoresPage from './pages/StaffStoresPage'
import { Toaster } from 'react-hot-toast'
import Test2 from './pages/Test2'
import StaffReservationsPage from './pages/StaffReservationsPage'
import ReferralCapture from './components/affiliate/ReferralCapture'
import AffiliatePage from './pages/AffiliatePage'
import AffiliateTermsPage from './pages/AffiliateTermsPage'
import AffiliateInvitePage from './pages/AffiliateInvitePage'
import AdminAffiliatesPage from './pages/AdminAffiliatesPage'
import AdminAffiliateDetailPage from './pages/AdminAffiliateDetailPage'
import AdminDroplistsPage from './pages/AdminDroplistsPage'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

// Keeps the footer pinned to the bottom on short pages
const Shell = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-height: 100dvh;
`

const Main = styled.main`
    flex: 1;
`

const App = () => {
    return (
        <>
            <GlobalStyles />
            <ToastContainer theme="dark" />
            <Toaster />
            <Auth>
                <>
                    <Router>
                        <ReferralCapture />
                        <Shell>
                            {/* Temp: show subs page when visiting index - / */}
                            <Nav />
                            <Main>
                                <Route exact path="/" component={Landing} />
                                <Route
                                    exact
                                    path="/r/:referralCode"
                                    component={ReferralLink}
                                />
                                <Route
                                    exact
                                    path="/release/:password"
                                    component={Release}
                                />
                                <Route
                                    exact
                                    path="/complete-account-setup/:token"
                                    component={AccountSetup}
                                />
                                <ProtectedRoute
                                    exact
                                    path="/subscriptions"
                                    component={Subscriptions}
                                />
                                {/* The release calendar was removed from the dashboard */}
                                <Route exact path="/release-calendar">
                                    <Redirect to="/subscriptions" />
                                </Route>
                                {/* Downloads now lives on the Subscriptions page */}
                                <Route exact path="/downloads">
                                    <Redirect to="/subscriptions" />
                                </Route>
                                <ProtectedRoute
                                    exact
                                    path="/settings"
                                    component={SettingsPage}
                                />
                                {/* The free-month referral program was replaced by the affiliate program */}
                                <Route exact path="/referrals">
                                    <Redirect to="/affiliate" />
                                </Route>
                                <ProtectedRoute
                                    exact
                                    path="/affiliate"
                                    component={AffiliatePage}
                                />
                                <Route
                                    exact
                                    path="/affiliate/terms"
                                    component={AffiliateTermsPage}
                                />
                                <ProtectedRoute
                                    exact
                                    path="/affiliate/invite/:token"
                                    component={AffiliateInvitePage}
                                />
                                <ProtectedRoute
                                    exact
                                    path="/admin/releases"
                                    component={AdminReleases}
                                />
                                <ProtectedRoute
                                    exact
                                    path="/admin/affiliates"
                                    component={AdminAffiliatesPage}
                                />
                                <ProtectedRoute
                                    exact
                                    path="/admin/affiliates/:affiliateId"
                                    component={AdminAffiliateDetailPage}
                                />
                                <ProtectedRoute
                                    exact
                                    path="/admin/droplists"
                                    component={AdminDroplistsPage}
                                />
                                <ProtectedRoute
                                    exact
                                    path="/staff/releases"
                                    component={StaffReleasesPage}
                                />
                                <ProtectedRoute
                                    exact
                                    path="/staff/stores"
                                    component={StaffStoresPage}
                                />
                                <ProtectedRoute
                                    exact
                                    path="/staff/reservations"
                                    component={StaffReservationsPage}
                                />
                                <ProtectedRoute
                                    exact
                                    path="/staff/alerts"
                                    component={StaffAlertsPage}
                                />
                                <ProtectedRoute
                                    exact
                                    path="/success"
                                    component={Success}
                                />
                                <ProtectedRouteWeak
                                    exact
                                    path="/setup"
                                    component={Setup}
                                />
                                <Route
                                    exact
                                    path="/privacy-policy"
                                    component={PrivacyPolicy}
                                />
                                <Route
                                    exact
                                    path="/cookie-policy"
                                    component={CookiePolicy}
                                />
                                <Route exact path="/tos" component={ToS} />
                            </Main>
                            <Footer />
                        </Shell>
                    </Router>
                </>
            </Auth>
            {/* <ReactQueryDevtools initialIsOpen={false} position='bottom-right' /> */}
        </>
    )
}

export default App
